export class CollapsibleNav {
	init() {
		const collapsibleNavs =
			document.querySelectorAll<HTMLElement>("nav.collapsible");
		const expandedHeights: any = {};

		window.addEventListener("resize", () => {
			collapsibleNavs.forEach(collapsibleNav => {
				expandedHeights[collapsibleNav as any] =
					this.getComputedHeight(collapsibleNav);
			});
		});

		collapsibleNavs.forEach(collapsibleNav => {
			const toggle = collapsibleNav.querySelector("button");

			if (toggle === null) {
				return;
			}
			expandedHeights[collapsibleNav as any] =
				this.getComputedHeight(collapsibleNav);

			toggle.addEventListener("click", () => {
				const expandedHeight = expandedHeights[collapsibleNav as any];
				const isCollapsed = collapsibleNav.classList.contains("collapse");

				if (isCollapsed) {
					collapsibleNav.classList.remove("collapse");
					collapsibleNav.style.height = expandedHeight;
				} else {
					collapsibleNav.classList.add("collapse");
					collapsibleNav.style.height = "";
				}
			});
		});
	}

	private getComputedHeight(navElement: HTMLElement): string {
		const collapseDefault = navElement.classList.contains("collapse");

		navElement.classList.remove("collapse");
		const expandedHeight = getComputedStyle(navElement).height;

		if (collapseDefault) {
			navElement.classList.add("collapse");
		}

		return expandedHeight;
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const collapsibleNav = new CollapsibleNav();
	collapsibleNav.init();
});
